import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpRequest} from '@angular/common/http';
import {catchError} from 'rxjs/operators';
import {NotificationService} from './notification.service';
import {EMPTY} from 'rxjs';
import {skipInterceptors} from '../helpers/request.helper';

@Injectable()
export class FileService {
    private securedUrl = '/api/secured/file';
    private repositoryUrl = '/api/secured/repository/files';

    constructor(
        private http: HttpClient,
        private notificationService: NotificationService
    ) {
    }

    postFile(file: File, repository = false) {
        const url = repository ? this.repositoryUrl : this.securedUrl;
        const formData = new FormData();
        formData.append('file', file, file?.name);
        const headers: HttpHeaders = skipInterceptors([400, 413]);
        const request = new HttpRequest('POST', url, formData, {
            headers,
            reportProgress: true,
            withCredentials: true
        });
        return this.http.request(request).pipe(
            catchError((httpError) => {
                if (httpError?.status === 400) {
                    if (Array.isArray(httpError?.error) && httpError?.error?.length > 0) {
                        const error = httpError?.error?.[0];
                        this.notificationService.error(error?.description || 'ERRORS.REQUEST_RESPONSE_400');
                    }
                }
                if (httpError?.status === 413) {
                    this.notificationService.error('ERRORS.INVALID_FILE_SIZE');
                }
                return EMPTY;
            })
        );
    }

    public getTokenByHash(hash: string) {
        this.http.get<{ token: string }>(`${this.securedUrl}/${hash}`)
            .subscribe(response => {
                this.getFileByToken(response.token);
            });
    }

    public getFileByToken(token: string) {
        window.location.href = `${this.securedUrl}/download/${token}`;
    }
}
